module.exports = __webpack_public_path__ + "img/attend_golden.8d512ad5.svg";